import { IUserSession } from '../../../helpers/user-session'

import { LoggerService } from '../../common/common.module'

import { ReportCreateEditController } from './reports-create-edit.directive.controller'

import { ReportHelper } from '../reports.helper'

//#region Asset Imports

import * as TEMPLATE from './reports-create-edit.tpl.html'

//#endregion

// Setup

export class ReportCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'logger', 'userSession', (
            $scope: any, 
            $q: ng.IQService, 
            $timeout: ng.ITimeoutService, 
            logger: LoggerService, 
            userSession: IUserSession
        ) => new ReportCreateEditController(
            $scope, 
            $q, 
            $timeout, 
            logger, 
            userSession, 
            ReportHelper.REFERENCE_TYPE,
            ReportHelper.SIMAX_MODULE_NAME 
        )]
            
    template = TEMPLATE
}

// Setup End